import { memo } from "react";
import { useAuth } from "react-oidc-context";
import { useIdleTimer } from "../../../lib/useIdleTimer/useIdleTimer";
import { IdleTimeoutDialog } from "../../molecules/IdleTimeoutDialog/IdleTimeoutDialog";

export const IdleTimerWrapper = memo(() => {
    const auth = useAuth();

    const { showWarning, remainingTime, handleStayActive } = useIdleTimer(
        () => {
            auth.signoutRedirect();
        }
    );

    return (
        <IdleTimeoutDialog
            open={showWarning}
            remainingTime={remainingTime}
            onStayActive={handleStayActive}
            onLogout={auth.signoutRedirect}
        />
    );
});

IdleTimerWrapper.displayName = "IdleTimerWrapper";
